import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Wraps the entire content in a div with classnames reflecting lastproduct and pathname.
 */
const AppWrapper = ({ children }) => {
	const pathname = useLocation()?.pathname ?? '';

	const className = useMemo(
		() => (pathname ? `wrapper-${pathname.replace(/\//g, '-').replace('-', '')}` : ''),
		[pathname]
	);

	return <div className={className}>{children}</div>;
};

export default AppWrapper;
